import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TwTcEppoViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { CodigoEppoPopupComponent } from '../../../core/components/popup/especies/codigoEppoPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { NombreCientificoService } from './nombrecientifico.service';
import { NombreCientificoViewModel } from './nombrecientifico.types';

@Component({
    selector: 'app-nombrecientifico-edit',
    templateUrl: './nombrecientifico-edit.component.html',
})
export class NombrecientificoEditComponent extends ComponentBase implements OnInit {
    @ViewChild(CodigoEppoPopupComponent) private codigoEppoPopupComponent: CodigoEppoPopupComponent;

    editMode: boolean;
    editTitle = 'Nuevo';
    nombreCientifico: NombreCientificoViewModel;
    visibilitySpinner = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private nombreCientificoService: NombreCientificoService,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.nombreCientifico = new NombreCientificoViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.nombreCientificoService.getDatosNombreCientificoById(id).subscribe(result => {
                this.nombreCientifico = result;
                this.updateForm();
            });
        }
    }

    createForm(): void {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            IdCodigoEppo: '',
            CodigoEppo: ['', Validators.required],
            Favorito: false,
        });
    }

    updateForm(): void {
        this.form.setValue({
            Descripcion: this.nombreCientifico.Descripcion,
            IdCodigoEppo: this.nombreCientifico.IdCodigoEppo,
            CodigoEppo: this.nombreCientifico.CodigoEppo,
            Favorito: this.nombreCientifico.Favorito,
        });
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let nombreCientifico = new NombreCientificoViewModel();

        nombreCientifico.Descripcion = this.form.value.Descripcion;
        nombreCientifico.IdCodigoEppo = this.form.value.IdCodigoEppo;
        nombreCientifico.CodigoEppo = this.form.value.CodigoEppo;
        nombreCientifico.Favorito = this.form.value.Favorito;

        nombreCientifico.Id = this.nombreCientifico.Id;

        if (this.editMode) {
            this.nombreCientificoService.editNombreCientifico(nombreCientifico).subscribe({
                next: res => {
                    this.addSuccessMessage('Nombre Cientí­fico modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.nombreCientificoService.createNombreCientifico(nombreCientifico).subscribe({
                next: res => {
                    this.addSuccessMessage('Nombre Cientí­fico añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack(): void {
        this.router.navigate(['/mantenimiento/especies/nombrescientificos']);
    }

    onSearchCodigoEppo(): void {
        this.codigoEppoPopupComponent.showDialog(null);
    }

    onAceptDialogCodigoEppo(codigoEppo: TwTcEppoViewModel): void {
        this.form.patchValue({
            CodigoEppo: codigoEppo.CodigoEppo,
            IdCodigoEppo: codigoEppo.Id,
        });
    }
}
